import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from '../admin.service';
import { AddCommentComponent } from './add-comment/add-comment.component';
import { CreateNewTicketComponent } from './create-new-ticket/create-new-ticket.component';
import { DeleteTicketComponent } from './delete-ticket/delete-ticket.component';
import { UpdateTicketComponent } from './update-ticket/update-ticket.component';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent implements OnInit {

  ticketList: any = [];
  openTicketStatus: boolean;
  closeTicketStatus: boolean;
  customerCatType: boolean;
  partnerCatType: boolean;
  searchTicketNo: string;
  activePage: number;
  perpage: number;
  lastNumber: number;
  activeTotal: number;
  activeFirstPage: boolean;
  noData: boolean;
  loginUserId: string;

  constructor( public dialog: MatDialog,  private adminService: AdminService) { }

  ngOnInit(): void {
    this.openTicketStatus = true;
    this.closeTicketStatus = true;
    this.customerCatType = true;
    this.partnerCatType = true;
    this.searchTicketNo = '';
    this.activePage = 1;
    this.perpage = 10;
    this.loginUserId = localStorage.getItem('id');
    this.getTicketList()
  }

  getTicketList() {
    let ticketStatus;
    let categoryType;
    if(this.openTicketStatus && this.closeTicketStatus) {
      ticketStatus = '';
    } else {
      ticketStatus = this.openTicketStatus ? 'open' : this.closeTicketStatus ? 'close' : ''
    }
    if(this.customerCatType && this.partnerCatType) {
      categoryType = '';
    } else {
      categoryType = this.customerCatType ? 'Technical Support' : this.partnerCatType ? 'partner order' : ''
    }
    this.adminService.getTicketsList(this.searchTicketNo, this.activePage - 1, this.perpage , ticketStatus , categoryType ).subscribe((response:any)=>{
      this.ticketList = response.data[0].list;    
      this.activeTotal = parseInt(response.data[0].total_count);
      this.lastNumber = this.activeTotal / this.perpage;



      if (this.activePage == 1) {
        this.activeFirstPage = true;
      } else {
        this.activeFirstPage = false;
      }

      if(this.activePage >= this.lastNumber) {
        this.noData = true;
      } else {
        this.noData = false;
      }
    });
  }

  previouspage() {
    this.activePage = this.activePage - 1;
    this.getTicketList();
  }

  nextPage() {
    this.activePage = this.activePage + 1;
    this.getTicketList();

  }

  filterByOpenTicketType(event) {
    if(event.target.checked) {
      this.openTicketStatus = true;
    } else {
      this.openTicketStatus = false;
    }
    this.getTicketList()
  }

  filterByCloseTicketType(event) {
    if(event.target.checked) {
      this.closeTicketStatus = true;
    } else {
      this.closeTicketStatus = false;
    }
    this.getTicketList()
  }

  filterByCustomerCatType(event) {
    if(event.target.checked) {
      this.customerCatType = true;
    } else {
      this.customerCatType = false;
    }
    this.getTicketList()
  }

  filterByPartnerCatType(event) {
    if(event.target.checked) {
      this.partnerCatType = true;
    } else {
      this.partnerCatType = false;
    }
    this.getTicketList()
  }
 
  gotonewticket() {
    const dialogRef = this.dialog.open(CreateNewTicketComponent,
      {
        panelClass: 'my-panel',
        disableClose: true
      });

    dialogRef.afterClosed().subscribe(
      res => {
        this.getTicketList();

      }
    )
  }

  gotoupdateticket(id) {
    const dialogRef = this.dialog.open(UpdateTicketComponent,
      {
        panelClass: 'my-panel',
        disableClose: true,
        data: { data: id }
      });

    dialogRef.afterClosed().subscribe(
      res => {
        this.getTicketList();

      }
    )


  }

  gotoAddComment(id) {
    const dialogRef = this.dialog.open(AddCommentComponent,
      {
        panelClass: 'my-panel',
        disableClose: true,
        data: { data: id }
      });

    dialogRef.afterClosed().subscribe(
      res => {
        this.getTicketList();

      }
    )


  }

  gotodeleteticket(id) {
    const dialogRef = this.dialog.open(DeleteTicketComponent,
      {
        panelClass: 'my-panel',
        disableClose: true,
        data: { data: id }
      });

    dialogRef.afterClosed().subscribe(
      res => {
        if(res) {
          if(res.data == 'Confirm') {
            this.getTicketList();
          }
        }      
        
      }
    )


  }

}
